/**
 * Returns `url` as an absolute href when it is an http: or https: URL,
 * otherwise "". Embedder-supplied links (terms of service, buy links) go
 * through it, so that a javascript: or data: URL is never rendered as a
 * link.
 */
export function safeHref(url) {
  if (!url) return "";
  try {
    const parsed = new URL(String(url), window.location.href);
    return parsed.protocol === "http:" || parsed.protocol === "https:"
      ? parsed.href
      : "";
  } catch {
    return "";
  }
}
